import { useState } from "react";
import DSBox from "views/system-design/DSBox";
import DSButton from "views/system-design/DSButton";
import DSChip from "views/system-design/DSChip";
import DSCircularProgress from "views/system-design/DSCircularProgress";
import DSTypography from "views/system-design/DSTypography";
import DSTable from "views/system-design/Table/DSTable";
import DSTableHead from "views/system-design/Table/DSTableHead";
import DSTableBody from "views/system-design/Table/DSTableBody";
import DSTableRow from "views/system-design/Table/DSTableRow";
import DSTableCell from "views/system-design/Table/DSTableCell";
import DSTableContainer from "views/system-design/Table/DSTableContainer";
import { AlertPolicy } from "../../../api/alertPolicies";
import { useAlertPolicies } from "../hooks/useAlertPolicies";
import AlertPolicyModal from "./AlertPolicyModal";

const AlertPolicies = () => {
  const { data: policies, isLoading } = useAlertPolicies();
  const [editing, setEditing] = useState<
    AlertPolicy | Record<string, never> | null
  >(null);

  return (
    <DSBox>
      <DSBox sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <DSButton
          variant="contained"
          size="small"
          onClick={() => setEditing({})}
        >
          New policy
        </DSButton>
      </DSBox>

      {isLoading ? (
        <DSBox sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <DSCircularProgress />
        </DSBox>
      ) : (
        <DSTableContainer>
          <DSTable size="small">
            <DSTableHead>
              <DSTableRow>
                <DSTableCell>Name</DSTableCell>
                <DSTableCell>Admins</DSTableCell>
                <DSTableCell>Monitors</DSTableCell>
              </DSTableRow>
            </DSTableHead>
            <DSTableBody>
              {policies?.map((policy) => (
                <DSTableRow
                  key={policy.id}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() => setEditing(policy)}
                >
                  <DSTableCell>
                    <DSBox
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <DSTypography variant="body2" fontWeight={500}>
                        {policy.name}
                      </DSTypography>
                      {policy.defaultForClockMonitors && (
                        <DSChip
                          label="Clock monitors default"
                          size="small"
                          color="info"
                          variant="outlined"
                        />
                      )}
                    </DSBox>
                  </DSTableCell>
                  <DSTableCell>
                    <DSTypography variant="caption" color="text.secondary">
                      {policy.adminUsers.length} admin
                      {policy.adminUsers.length === 1 ? "" : "s"}
                    </DSTypography>
                  </DSTableCell>
                  <DSTableCell>
                    <DSTypography variant="caption" color="text.secondary">
                      {policy.monitorCount ?? 0}
                    </DSTypography>
                  </DSTableCell>
                </DSTableRow>
              ))}
            </DSTableBody>
          </DSTable>
        </DSTableContainer>
      )}

      <AlertPolicyModal policy={editing} onClose={() => setEditing(null)} />
    </DSBox>
  );
};

export default AlertPolicies;
